import { BROWSER_UI_EVENT_BUFFER_STORAGE } from '../../../shared/uiEvent/useRecordUIEvent/uiEventBuffer/browserUIEventBufferStorage';
import { clearUIEventBuffer } from '../../../shared/uiEvent/useRecordUIEvent/uiEventBuffer/clearUIEventBuffer/clearUIEventBuffer';

/**
 * Throws away this browser's queue of unsent events on sign-out.
 *
 * The send derives the person from the session, so a leftover queue would be
 * filed under whoever signs in next, and Caio and David sign in as workers all
 * winter. Losing a few events beats misattributing them.
 *
 * Takes no store: the browser queue is the only one a signed-in app writes to.
 *
 * Called from all three login pages' mount effect (covers expiry and logout)
 * and the worker app's two logouts, the worker app's through its
 * `clearWorkerDevice`. Residual case: an expiry, a re-login as
 * someone else within the 12-hour cap, and one successful event replays the
 * first person's queue under the second. So read a suspicious row with
 * `buffered_ms` beside `ip`.
 */
export function clearBrowserUIEventBuffer(): void {
  clearUIEventBuffer(BROWSER_UI_EVENT_BUFFER_STORAGE);
}
